import React from "react";
import { useForm, useFieldArray } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../../styles/Admin.css";

const FormBurgerExtras = ({
  selectedBurger,
  allExtras,
  burgerExtras,
  handleUpdateExtras,
}) => {
  const extrasMap = Object.fromEntries(
    burgerExtras.map((e) => [e.addon_id, true])
  );

  const defaultValues = {
    extras: allExtras.map((extra) => ({
      addon_id: extra.id,
      addon_name: extra.addon_name,
      extra_price: extra.extra_price,
      checked: !!extrasMap[extra.id],
    })),
  };

  const { register, handleSubmit, control } = useForm({
    defaultValues,
  });

  const { fields } = useFieldArray({
    control,
    name: "extras",
  });

  const onSubmit = (data) => {
    const extras = data.extras.map((e) => ({
      ...e,
      burger_type: selectedBurger.id,
    }));
    handleUpdateExtras(extras);
  };

  return (
    <div className="container">
      <div className="burger-extras-container mx-auto">
        <h4 className="text-center fw-bold products-title mb-4">
          Hamburguesa {selectedBurger.type_description}
        </h4>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th scope="col">Extra</th>
                  <th scope="col">Precio</th>
                  <th scope="col">Incluir</th>
                </tr>
              </thead>
              <tbody>
                {fields.map((field, index) => (
                  <tr key={field.id}>
                    <td>
                      <input
                        type="hidden"
                        {...register(`extras.${index}.addon_id`)}
                      />
                      <input
                        type="hidden"
                        {...register(`extras.${index}.addon_name`)}
                      />
                      <input
                        type="hidden"
                        {...register(`extras.${index}.extra_price`)}
                      />
                      {field.addon_name}
                    </td>
                    <td>${field.extra_price}</td>
                    <td>
                      <input
                        type="checkbox"
                        {...register(`extras.${index}.checked`)}
                        className="form-check-input"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="text-center mt-4">
            <button type="submit" className="btn btn-success me-3">
              Guardar Cambios
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FormBurgerExtras;